function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgHome(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M20.038 21.05c.277 0 .534-.093.72-.245.187-.153.304-.367.291-.606V8.498a.8.8 0 0 0-.296-.607l-8.039-6.693a1.152 1.152 0 0 0-1.429 0L3.246 7.87a.8.8 0 0 0-.296.607v11.702c0 .478.461.85 1.01.85H8.79c.701 0 1.289-.477 1.289-1.081v-3.852c0-.343.348-.644.784-.644h2.25c.436 0 .784.301.784.644v3.873c0 .604.588 1.081 1.289 1.081zm-.48-12.381v11.123h-4.146v-3.696c0-1.067-1.043-1.902-2.275-1.902h-2.25c-1.258 0-2.274.856-2.274 1.902v3.675H4.44V8.648L12 2.375Z",
    style: {
      fill: "currentColor",
      stroke: "currentColor",
      strokeWidth: 0.1
    }
  }));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHome);
export default __webpack_public_path__ + "static/media/home.b4e02f2b.svg";
export { ForwardRef as ReactComponent };